exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.diff[data-v-79d6394f] {\n  text-align: right;\n}\n.overview-row[data-v-79d6394f] {\n  margin-bottom: 16px;\n}\n", ""]);

